var React = require('react');

function BurgerMenu (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"21","y":"198.164","width":"214","height":"23.4521","rx":"11.726","fill":"#444444","key":0}),React.createElement("rect",{"x":"21","y":"116.082","width":"214","height":"23.4521","rx":"11.726","fill":"#444444","key":1}),React.createElement("rect",{"x":"21","y":"34","width":"214","height":"23.4521","rx":"11.726","fill":"#444444","key":2})]);
}

BurgerMenu.defaultProps = {"width":"256","height":"256","viewBox":"0 0 256 256","fill":"none"};

module.exports = BurgerMenu;

BurgerMenu.default = BurgerMenu;
